import { defineWidgets } from "../utils/defineWidgets.ts";

export const widgets = defineWidgets({
  "ld-driver-stats": () => import("./driver-statistics/driver-statistics.tsx"),
  "ld-season-ranking-gallery": () => import("./season-ranking-gallery/season-ranking-gallery.tsx"),
  "ld-team-driver-page": () => import("./teams-drivers/teams-drivers.tsx"),
  "ld-podium-list": () => import("./podium-list/podium-list.tsx"),
  "ld-motorsports-live-score": () => import("./live-score/live-score.tsx"),
  "ld-gp-calendar": () => import("./gp-calendar/competition-calendar.tsx"),
  "ld-gp-current-calendar": () => import("./gp-current-calendar/current-calendar.tsx"),
  "ld-motorsports-team-ranking": () => import("./teams-ranking/teams-ranking.tsx"),
  "ld-motorsports-driver-ranking": () => import("./drivers-ranking/drivers-ranking.tsx")
});

export const widgetsLgp = defineWidgets({
  "ld-lgp-hero": () => import("./lgp-hero/lgp-hero.tsx"),
  "ld-lgp-hero-sticky": () => import("./lgp-hero-sticky/lgp-hero-sticky.tsx"),
  "ld-lgp-preview": () => import("./lgp-preview/lgp-preview.tsx"),
  "ld-lgp-results-container": () => import("./lgp-results-container/lgp-results-container.tsx"),
  "ld-lgp-results": () => import("./lgp-results/lgp-results.tsx"),
});

export const widgetsDataCards = defineWidgets({
  "ld-card-gp-calendar": () => import("./data-card-calendar/data-card-calendar.tsx"),
  "ld-card-gp-results": () => import("./data-card-gp-results/data-card-gp-results.tsx"),
  "ld-card-driver-ranking": () => import("./data-card-driver-ranking/data-card-driver-ranking.tsx"),
  "ld-card-gp-team-ranking": () => import("./data-card-team-ranking/data-card-team-ranking.tsx"),
});

export const widgetsMap = {
  ...widgets,
  ...widgetsLgp,
  ...widgetsDataCards,
};
